/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PublicBookingEntity = {
    id: string;
    bookingStatus: PublicBookingEntity.bookingStatus;
    orderId: string | null;
    meetingId: string;
    /**
     * The date and time until the booking doesn't block a spot in the meeting anymore.
     */
    exclusiveUntil: string | null;
    guestId: string | null;
    customerId: string | null;
    replaced: boolean;
    multipassId: string | null;
    courseGroupId: string | null;
    multipassProductId: string | null;
    priceInMillsOverride: number | null;
    rebateCodeId: string;
};
export namespace PublicBookingEntity {
    export enum bookingStatus {
        RESERVED = 'RESERVED',
        CLAIMED = 'CLAIMED',
        FULFILLED = 'FULFILLED',
        REFUNDED = 'REFUNDED',
        CANCELLED = 'CANCELLED',
        CANCELLED_REFUNDED = 'CANCELLED_REFUNDED',
        WITHDRAWN = 'WITHDRAWN',
    }
}

